import React from 'react';

import './style.scss';

const Client = ({ client }) => {
  return (
    <div className="client">
      <img className="client__logo" src={client.logo.resolutions.src} title={client.name} alt={client.name} />
    </div>
  )
}

const Clients = ({ clients }) => {
  return (
    <div className="clients">
      <ul className="clients__list">
        {clients.map((client, index) => {
          return (
            <li className="clients__element" key={index}>
              <Client client={client} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Clients;


// WEBPACK FOOTER //
// ./src/components/Clients/index.js